// TODO: Wait for document to load in
(function() {
  /**
   * Debounces a function. Only calls it once it has been quiet for <delay> milliseconds
   * @param callback Function to call
   * @param delay How long the debounced function needs to go without being called, before trigger the callback
   */
  function debounce(callback, delay = 250) {
    let timeout = undefined;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        timeout = undefined;
        callback.apply(context, args);
      }, delay);
    };
  }

  class MobileMenu {
    constructor(menu_element) {
      this._root_element = menu_element;
      this._max_window_size = 840;
      this._can_be_enabled = false;
      this._is_enabled = false;

      if (this._root_element.dataset.maxWindowSize) {
        const temp = parseInt(this._root_element.dataset.maxWindowSize, 10);
        if (!isNaN(temp)) {
          this._max_window_size = temp;
        }
      }

      this._expandables = this._root_element.querySelectorAll('.js-mobile-menu__item.has-children');
      for (let i = 0; i < this._expandables.length; i++) {
        const item = this._expandables[i];
        const label = item.querySelector('.js-mobile-menu__label')
        if (!label) {
          continue;
        }

        label.addEventListener('click', () => this.handleExpandableClick(item, label));
      }

      this._activator_buttons = document.querySelectorAll('.js-activate-mobile-menu');
      for (let i = 0; i < this._activator_buttons.length; i++) {
        const button = this._activator_buttons[i];
        button.addEventListener('click', () => this.toggleActive());
      }

      // Run once to correctly set variables
      this.handleWindowResize();
      window.addEventListener('resize', debounce(() => this.handleWindowResize(), 200));

      // TODO: Listen for a button to be clicked
      // this.activate();
    }

    activate() {
      if (!this._can_be_enabled) {
        return;
      }
      if (this._is_enabled) {
        return;
      }

      this._is_enabled = true;
      document.documentElement.classList.add('is-mobile-menu-active');
    }

    deactivate() {
      if (!this._is_enabled) {
        return;
      }

      this._is_enabled = false;
      document.documentElement.classList.remove('is-mobile-menu-active');
    }

    toggleActive() {
      if (!this._is_enabled) {
        this.activate();
        return;
      }

      this.deactivate();
    }

    handleWindowResize() {
      if (window.innerWidth > this._max_window_size) {
        this._can_be_enabled = false;
        this.deactivate();
        return;
      }

      this._can_be_enabled = true;
    }

    handleExpandableClick(item, _label) {
      item.classList.toggle('is-active');
    }
  }

  function main() {
    const menu = document.querySelector('.js-mobile-menu');
    if (menu) {
      new MobileMenu(menu);
    }
  }

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    main();
  } else {
    document.addEventListener('DOMContentLoaded', main);
  }
})();
